import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Login from "./pages/Login"; // Ensure you created this file in src/pages
import Profile from "./pages/Profile";
import UserTickets from "./pages/UserTickets";
import TicketManager from "./pages/TicketManager";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        {/* You can add placeholders for the redirect pages here */}
        <Route path="/user-tickets" element={<UserTickets />} />
        <Route path="/ticket-manager" element={<TicketManager />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
    </Router>
  );
}

export default App;